import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
  navTheme: "white", // 导航栏主题 white-白色（默认） black-黑色
  navFixed: false, // 是否固定导航
};

const mutations = {
  NAV_THEME(state, theme) {
    state.navTheme = theme
  },
  NAV_FIXED(state, fixed) {
    state.navFixed = fixed
  }
};

const actions = {
  setNavTheme({ commit }, theme) {
    commit("NAV_THEME", theme)
  },
  setNavFixed({ commit }, fixed) {
    commit("NAV_FIXED", fixed)
  }
};

const getters = {
  navTheme: state => state.navTheme,
  navFixed: state => state.navFixed
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});



// WEBPACK FOOTER //
// ./src/store/index.js